// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__27Rem","icon":"SortAdornment_icon__3ZOjI","up":"SortAdornment_up__2nF-I","down":"SortAdornment_down__18kXC","active":"SortAdornment_active__3nwp4"};